import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatStepper} from '@angular/material';
import {DelegationListComponent} from '../delegation-list/delegation-list.component';
import { MatOption, MatCheckboxChange, MatSelect } from '@angular/material';
import {DelegationService} from '../delegation.service';
import {
  DelegationHabilitationParams,
  DelegationItem,
  DelegationRequestModel, DelegationUo, DelegationUoVo, TypeSelectDelegation
} from 'app/modules/delegation/delegation.model';
import {indexOf} from 'lodash';
import {ToastrService} from 'ngx-toastr';
import {DelegationList} from '../../../model/delegationList';

@Component({
  selector: 'app-modal-edit-delegation',
  templateUrl: './modal-delete-delegation.component.html',
  styleUrls: ['./modal-delete-delegation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ModalDeleteDelegationComponent implements OnInit {


  constructor(public dialog: MatDialog,
              public dialogRef: MatDialogRef<DelegationListComponent>,
              private delegationService: DelegationService,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  selected: DelegationItem ;
  delegationDeleted: any ;

  @ViewChild('select') unitSelect: MatSelect;
  @ViewChild('select') collabSelect: MatSelect;

  ngOnInit() {
    this.selected = this.data.delegator;
    this.delegationDeleted = this.data.delegator;

  }
  // Event fired after view is initialized

  confirmDeleteDelegation() {
    this.delegationService.deleteDelegation(this.delegationDeleted.id,this.delegationDeleted.delegate)
      .subscribe(res=> {
        this.dialog.closeAll();
        this.delegationService.redirectTo('delegation');
      })
  }

  cancelDeleteDelegation() {
    this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/modal-delete-delegation/modal-delete-delegation.component.ts